import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _d786f232 = () => interopDefault(import('../../../pages/about.vue' /* webpackChunkName: "pages/about" */))
const _79b33d7a = () => interopDefault(import('../../../pages/contact.vue' /* webpackChunkName: "pages/contact" */))
const _7d9c04c3 = () => interopDefault(import('../../../pages/login.vue' /* webpackChunkName: "pages/login" */))
const _7683accf = () => interopDefault(import('../../../pages/newsletter.vue' /* webpackChunkName: "pages/newsletter" */))
const _a9442ca6 = () => interopDefault(import('../../../pages/offers.vue' /* webpackChunkName: "pages/offers" */))
const _a7530d0c = () => interopDefault(import('../../../pages/organizations.vue' /* webpackChunkName: "pages/organizations" */))
const _3878167d = () => interopDefault(import('../../../pages/products/index.vue' /* webpackChunkName: "pages/products/index" */))
const _fc4a92fa = () => interopDefault(import('../../../pages/profile.vue' /* webpackChunkName: "pages/profile" */))
const _1a8e56c2 = () => interopDefault(import('../../../pages/recipes/index.vue' /* webpackChunkName: "pages/recipes/index" */))
const _0d5f3939 = () => interopDefault(import('../../../pages/register.vue' /* webpackChunkName: "pages/register" */))
const _7656ad3e = () => interopDefault(import('../../../pages/search.vue' /* webpackChunkName: "pages/search" */))
const _d9f9f28e = () => interopDefault(import('../../../pages/settings.vue' /* webpackChunkName: "pages/settings" */))
const _20f9601c = () => interopDefault(import('../../../pages/shoppinglist.vue' /* webpackChunkName: "pages/shoppinglist" */))
const _202c1330 = () => interopDefault(import('../../../pages/tasks.vue' /* webpackChunkName: "pages/tasks" */))
const _1f90aa30 = () => interopDefault(import('../../../pages/products/_id/index.vue' /* webpackChunkName: "pages/products/_id/index" */))
const _60fa40ad = () => interopDefault(import('../../../pages/recipes/_id/index.vue' /* webpackChunkName: "pages/recipes/_id/index" */))
const _3ad098ff = () => interopDefault(import('../../../pages/recipes/_id/edit.vue' /* webpackChunkName: "pages/recipes/_id/edit" */))
const _98173ca8 = () => interopDefault(import('../../../pages/index.vue' /* webpackChunkName: "pages/index" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/about",
    component: _d786f232,
    name: "about___en"
  }, {
    path: "/contact",
    component: _79b33d7a,
    name: "contact___en"
  }, {
    path: "/login",
    component: _7d9c04c3,
    name: "login___en"
  }, {
    path: "/newsletter",
    component: _7683accf,
    name: "newsletter___en"
  }, {
    path: "/offers",
    component: _a9442ca6,
    name: "offers___en"
  }, {
    path: "/organizations",
    component: _a7530d0c,
    name: "organizations___en"
  }, {
    path: "/products",
    component: _3878167d,
    name: "products___en"
  }, {
    path: "/profile",
    component: _fc4a92fa,
    name: "profile___en"
  }, {
    path: "/recipes",
    component: _1a8e56c2,
    name: "recipes___en"
  }, {
    path: "/register",
    component: _0d5f3939,
    name: "register___en"
  }, {
    path: "/search",
    component: _7656ad3e,
    name: "search___en"
  }, {
    path: "/settings",
    component: _d9f9f28e,
    name: "settings___en"
  }, {
    path: "/shoppinglist",
    component: _20f9601c,
    name: "shoppinglist___en"
  }, {
    path: "/tasks",
    component: _202c1330,
    name: "tasks___en"
  }, {
    path: "/products/:id",
    component: _1f90aa30,
    name: "products-id___en"
  }, {
    path: "/recipes/:id",
    component: _60fa40ad,
    name: "recipes-id___en"
  }, {
    path: "/recipes/:id/edit",
    component: _3ad098ff,
    name: "recipes-id-edit___en"
  }, {
    path: "/",
    component: _98173ca8,
    name: "index___en"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
